<template>
    <div class="spotlight-result-item" :class="{ 'spotlight-result-item--focused': focused }" @click="$emit('select', item)">
        <div class="spotlight-result-icon spotlight-result-icon--vehicle">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 17h14M5 17a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1l2-3h8l2 3h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2"/><circle cx="7.5" cy="17" r="2"/><circle cx="16.5" cy="17" r="2"/></svg>
        </div>
        <div class="spotlight-result-text">
            <div class="spotlight-result-title">{{ item.title }}</div>
            <div v-if="item.subtitle" class="spotlight-result-subtitle">{{ item.subtitle }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VehicleResult',
    props: { item: Object, focused: Boolean },
    emits: ['select']
}
</script>
